import { Locale } from '@/constants/locales';

export type TicketHolderInfo = {
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  streetName: string;
  streetNumber: string;
  city: string;
  country: string;
  zip: string;
  photo?: boolean;
};

export type TicketHolderDataProperty = keyof TicketHolderInfo;
export type TicketHolderFormField = {
  name: TicketHolderDataProperty;
  required: boolean;
};
export type TicketHolderFormSchemaItem = TicketHolderFormField;
export type TicketHolder = {
  id: string;
  ticketId: string;
  data: TicketHolderInfo;
};

export type Photo = {
  photoId: string;
};
export type OrderType = 'OPEN_DATE_TICKET' | 'FLEX_OFFER' | 'SEASON_PASS';

export const FLEX_TICKET_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
} as const;

export const TICKET_STATUS = {
  PENDING_TICKET_HOLDER_INFO: 'PENDING_TICKET_HOLDER_INFO',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
} as const;

export type FlexTicketStatusType = (typeof FLEX_TICKET_STATUS)[keyof typeof FLEX_TICKET_STATUS];
export type OrderItemTicketStatus = (typeof TICKET_STATUS)[keyof typeof TICKET_STATUS];
export type OrderItemTicket = {
  code: string;
  id: string;
  status: OrderItemTicketStatus;
};
export type OrderItem = {
  type: OrderType;
  id: string;
  name: string;
  status: FlexTicketStatusType;
  tickets: OrderItemTicket[];
  restrictions: {
    ticketHolderInfo: TicketHolderFormField[];
  };
};

export type OrderDetails = {
  id: string;
  code: string;
  locale: Locale;
  orderItems: OrderItem[];
};
